import React from "react";
import AnniversariesPage from "@pages/Anniversaries/AnniversariesPage";
import ProtectedRoute from "@components/routes/ProtectedRoute";

export default [
    {
        path: "anniversaries",
        element: <ProtectedRoute allowedRoles={["root_admin", "business_admin", "demo"]} />,
        children: [
            {
                path: "",
                element: <AnniversariesPage />,
            },
        ],
    },
];
